import { SVGProps } from 'react';

export const CrossIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.90899 10.5091C10.0659 10.6668 10.3204 10.6668 10.4773 10.5091C10.6343 10.3514 10.6343 10.0957 10.4773 9.93799L7.84685 7.29476L10.5096 4.61905C10.6666 4.46135 10.6666 4.20566 10.5096 4.04796C10.3527 3.89026 10.0983 3.89026 9.94131 4.04796L7.27852 6.72367L4.61572 4.04796C4.45878 3.89026 4.20433 3.89026 4.04739 4.04796C3.89045 4.20566 3.89045 4.46135 4.04739 4.61905L6.71018 7.29476L4.07971 9.938C3.92277 10.0957 3.92277 10.3514 4.07971 10.5091C4.23665 10.6668 4.4911 10.6668 4.64804 10.5091L7.27852 7.86585L9.90899 10.5091Z"
            fill="#202020"
        />
    </svg>
);
